import { render, staticRenderFns } from "./RequestCreate.vue?vue&type=template&id=51c1bf69"
import script from "./RequestCreate.vue?vue&type=script&lang=js"
export * from "./RequestCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports